import type { ResearchConfigurationLiteItem } from '@types';
import { getUserConfigurationsLite } from '../../../services/configurationManager';
import { researchConfigurationsLiteQueryKey } from '../../../hooks/queries/keys';
import {
  SESSION_GROUP_QUERY_GC_TIME,
  SESSION_GROUP_QUERY_STALE_TIME,
} from './constants';

export const sessionLiteQueryOptions = (userId: string, sessionId: number) => ({
  queryKey: researchConfigurationsLiteQueryKey(userId, {
    status: 'completed',
    searchId: String(sessionId),
    page: 1,
    size: 1,
  }),
  queryFn: async (): Promise<ResearchConfigurationLiteItem | null> => {
    const response = await getUserConfigurationsLite(userId, {
      status: 'completed',
      searchId: String(sessionId),
      page: 1,
      size: 1,
    });

    const item =
      response.items.find(entry => entry.id === sessionId) ?? response.items[0];

    if (item?.id === sessionId) {
      return item;
    }

    return null;
  },
  staleTime: SESSION_GROUP_QUERY_STALE_TIME,
  gcTime: SESSION_GROUP_QUERY_GC_TIME,
  refetchOnWindowFocus: false,
});
